export const statusValues = ['online', 'busy', 'away', 'offline'];
export const getAvatarColorBg = id => {
  return `var(--sinch-comp-avatar-container-color-${id}-background)`;
};
export const getAvatarColorFg = id => {
  return `var(--sinch-comp-avatar-container-color-${id}-foreground)`;
};